export const UPLOAD_VENUE_IMAGES = 'app/VenueModal/UPLOAD_VENUE_IMAGES';
export const GET_COUNTRIES = 'app/VenueModal/GET_COUNTRIES';
export const CLEAN_STORE = 'app/VenueModal/CLEAN_STORE';
export const GET_MEDIA = 'app/VenueModal/GET_MEDIA';
export const DELETE_MEDIA = 'app/VenueModal/DELETE_MEDIA';
export const GET_IMAGE_FORMATS = 'app/VenueModal/GET_IMAGE_FORMATS';
